import React, { Context } from 'react';

import {
  ReactReduxContextValue,
  createStoreHook,
  createDispatchHook,
  createSelectorHook,
  Provider,
} from 'react-redux';
import { AnyAction, createStore } from 'redux';
import { CitationGeneratorStates } from '../types';
import { citationGenerationReducer } from './reducer';

interface CitationGeneratorProps {
  children: JSX.Element[] | JSX.Element;
}

const citationGeneratorContext: Context<
  ReactReduxContextValue<CitationGeneratorStates, AnyAction>
> = React.createContext(null) as unknown as Context<
  ReactReduxContextValue<CitationGeneratorStates, AnyAction>
>;

export const useCitationGeneratorStore = createStoreHook(citationGeneratorContext);
export const useCitationGeneratorDispatch = createDispatchHook(citationGeneratorContext);
export const useCitationGeneratorState = createSelectorHook(citationGeneratorContext);

const resultsStore = createStore(citationGenerationReducer as any);

export function CitationGeneratorProvider({ children }: CitationGeneratorProps) {
  return (
    <Provider context={citationGeneratorContext} store={resultsStore}>
      {children}
    </Provider>
  );
}
